import './sidemenu.scss';

/**
 * version    1.0
 * class      Sidemenu
 */
export class Sidemenu {
  constructor() {
    $(() => {
      this._initAccessibility();
    });
  }

  _initAccessibility() {
    const $currentLi = $('#sidenavbar .sidemenu__nav li.active').last();
    const $currentLink = $currentLi.children('a');

    if ($currentLink.length > 0) {
      $currentLink.attr('aria-current', 'page');
    }
  }
}
